import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PlaywireRampProps {
    /** Your Playwire Publisher ID */
    PUB_ID: string;
    /** Your Playwire Website ID */
    WEBSITE_ID: string;
}

declare global {
    interface Window {
        ramp: any;
    }
}

const PlaywireRamp: React.FC<PlaywireRampProps> = (props: PlaywireRampProps) => {
    const { PUB_ID, WEBSITE_ID } = props;
    const [rampComponentLoaded, setRampComponentLoaded] = useState(false);
    const location = useLocation(); // React Router hook to get the current location

    useEffect(() => {
        if (!rampComponentLoaded) {
            setRampComponentLoaded(true);
            window.ramp = window.ramp || {};
            window.ramp.que = window.ramp.que || [];

            // Load the Ramp configuration script
            const configScript = document.createElement('script');
            configScript.dataset.cfasync = 'false'; // cloudflare support
            configScript.src = `https://cdn.intergient.com/${PUB_ID}/${WEBSITE_ID}/ramp.js`;
            document.body.appendChild(configScript);

            configScript.onload = () => {
                window.ramp.que.push(() => {
                    window.ramp.spaNewPage(location.pathname);
                });
            };
        }

        // Handle page navigation
        window.ramp.que.push(() => {
            window.ramp.spaNewPage(location.pathname);
        });

        // Cleanup function to handle component unmount
        return () => {
            window.ramp.que.push(() => {
                window.ramp.spaNewPage(location.pathname);
            });
        };
    }, [rampComponentLoaded, location.pathname, PUB_ID, WEBSITE_ID]);

    return null;
}

export default PlaywireRamp;
